export const CACHE_HEADER = 'x-fr-cache';

export enum EndpointKeys {
  EXCEPTION_HEADER_VALUE = 'EXCEPTION_HEADER_VALUE',
  PAYMENT_V2 = 'PAYMENT_V2',
  PAYMENT_AWS = 'PAYMENT_AWS'
}
export enum HTTP_HEADERS {
  TRANSACTION_ID_PREFIX = 'my-trips',
  APP_ID = 'WEB',
  CONTENT_TYPE = 'application/json; charset=UTF-8',
  MY_TRIP = 'MyTrip',
  CHANNEL_ID = 'DCOM',
  GUEST = 'GUEST',
  PURCHASE_PATH = 'MYTRIPS'
}
export const TRANCSACTION_ID = 'transactionid';
export const IDP_APP = 'MY_TRIPS';
export const TRANSACTION_ID_EXCLUDE = [
  'graphql',
  'customsearch',
  'signin-si.delta.com',
  'encrypt-decrypt-api',
  'signin.delta.com',
  'dlvacations-api',
  'displaystandbylist-api',
  'rebookClean'
];

export const EXCEPTION_HEADER_SUBDOMAINS = [
  'mytrips-api-si.vs01.vs.air4.com',
  'specialservicerequest-api-si.vs01.vs.air4.com',
  'messagecenter-api-si.vs01.vs.air4.com',
  'passengerinfo-api-si.vs01.vs.air4.com'
];

export const SUBDOMAINS_INCLUDED = [
  'mytrips-api.delta.com',
  'passengerinfo-api.delta.com',
  'specialservicerequest-api.delta.com',
  'compupgrade-api.delta.com',
  'messagecenter-api.delta.com',
  'mytrips-api-si.delta.com',
  'passengerinfo-api-si.delta.com',
  'specialservicerequest-api-si.delta.com',
  'compupgrade-api-si.delta.com',
  'messagecenter-api-si.delta.com',
  'mytrips-api-dev.delta.com',
  'passengerinfo-api-dev.delta.com',
  'specialservicerequest-api-dev.delta.com',
  'compupgrade-api-dev.delta.com',
  'messagecenter-api-dev.delta.com',
  'mytrips-api-si.vs01.vs.air4.com',
  'specialservicerequest-api-si.vs01.vs.air4.com',
  'messagecenter-api-si.vs01.vs.air4.com',
  'passengerinfo-api-si.vs01.vs.air4.com',
  'messagecenter-api.vs.air4.com',
  'passengerinfo-api.vs.air4.com',
  'specialservicerequest-api.vs.air4.com',
  'mytrips-api.vs.air4.com'
];

export const POST_CACHEABLE = ['/login/login/getDashBrdData'];

export const TIMEOUT = 'TIMEOUT';
